module.exports = __webpack_public_path__ + "img/promo@2x.90ea1a90.png";